<div class="submit-container">
  <ng-content></ng-content>
  <rk-hotkeys-help-clue
    *ngIf="!disable"
    [hotkey]="'confirm'"
    [context]="'inTooltip'"
    class="shortcut"
  ></rk-hotkeys-help-clue>
</div>
